import script from "./competency-accordion.vue?vue&type=script&lang=ts&setup=true"
export * from "./competency-accordion.vue?vue&type=script&lang=ts&setup=true"

import "./competency-accordion.vue?vue&type=style&index=0&id=87256014&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-87256014"]])

export default __exports__